import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as LoadingSvg } from "../assets/loading.svg";
import hokodoLogo from "../assets/hokodo.svg";

class SingleInvoiceRedirect extends Component {
  componentDidMount() {
      this.timeout = setTimeout(() => {
        window.location.replace(this.props.singleInvoiceReferralUrl);
      }, 5000);
  }

  componentWillUnmount() {
      if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
      }
  }

  render() {
    const props = this.props;

    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <div className="form_content">
              <div className="form_content">
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ height: 20, width: 20, marginRight: 20 }}>
                        <LoadingSvg />
                    </div>
                    <p><strong>We're redirecting you to Hokodo now...</strong></p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 50, marginBottom: 50 }}>
                    <img src={props.domain.LogoUrl} alt="logo" style={{ maxWidth: "40%" }} />
                    <div style={{ width: 173, maxWidth: "40%" }}>
                        <img src={hokodoLogo} alt="Hokodo" />
                    </div>
                  </div>
                  <p style={{ textAlign: 'center' }}>If you aren't redirected during 5 seconds, <a href={this.props.singleInvoiceReferralUrl} style={{ color: '#eb910c' }}>Click here</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.app
  };
};

export default connect(
  mapStateToProps,
  null
)(SingleInvoiceRedirect);
